import React from 'react';
import withView from '../../cmn/docAutomation/withView';
import FormInput from '../../../library/form/components/FormInput';
import FormLabel from '../../../library/form/components/FormLabel'
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import FormSH from '../../../library/form/components/FormSH';
import { UiCol, UiGridColOne, UiViewContent } from '../../../library/layout/Index';

const InvTrnTermsEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;
    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }}
            formStyle={{ height: '350px' }}
            contentStyle={{ height: '250px', width: "360px" }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >
            <UiViewContent>
                <UiGridColOne>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentTerms" }} value="Payment Terms" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "input", paramName: "paymentTerms" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "paymentMode" }} value="Payment Mode" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "paymentMode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />

                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "paymentMode",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                        ></FormSH>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "creditDays" }} value="Credit Days" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "input", paramName: "creditDays" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "payDate" }} value="Payment Date" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "dp", paramName: "payDate" }} />
                            </li>
                            <li style={{display:'none'}}>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "delDate" }} value="Delivery Date" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="relationSince" className="uiInput"
                                    action={{ InputType: "dp", paramName: "delDate" }} />
                            </li>
                            <li style={{display:'none'}}>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "TransMode" }} value="Delivery Mode" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput"
                                    action={{ InputType: "ac", paramName: "TransMode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }} />

                                <FormSH formObject={formObject} rowKey=""
                                    action={{ actionId: "new", paramName: "TransMode",  actionName: "catDetail", actionParam: {}, containerKey: "popup" }}
                                    ></FormSH>
                            </li>
                        </ul>
                    </UiCol>
                </UiGridColOne>
            </UiViewContent>

            <ul className="uiHeaderForm">
            </ul>
        </FormDialog>
    )
}

export default withView(InvTrnTermsEditor, "invTrnTerms", "invTrnTerms")